export const CampaignsListLocalStorageKeys = {
  CAMPAIGNS_LIST_FILTER_FORMAT: 'campaigns-list-filter-format',
  CAMPAIGNS_LIST_FILTER_STATUS: 'campaigns-list-filter-status',
  CAMPAIGNS_LIST_FILTER_TYPE: 'campaigns-list-filter-type',
  CAMPAIGNS_LIST_FILTER_START_DATE: 'campaigns-list-filter-startDate',
  CAMPAIGNS_LIST_FILTER_END_DATE: 'campaigns-list-filter-endDate',
  CAMPAIGNS_LIST_FILTER_SEARCH: 'campaigns-list-filter-search',
} as const;
